export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/customer-support.7f3b4be1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};